import API from './api';

const login = async (email, password) => {
  const response = await API.post('/admin/login', { email, password });
  if (response.data.token) {
    localStorage.setItem('user', JSON.stringify(response.data));
  }
  return response.data;
};

const logout = () => {
  localStorage.removeItem('user');
};

const registerAdmin = (fullName, email, password) => {
  return API.post('/admin/register', { fullName, email, password });
};

const listAdmins = () => {
  return API.get('/admins');
};

const updateAdmin = (email, data) => {
  return API.put(`/admins/${email}`, data);
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('user'));
};

const authService = {
  registerAdmin,
  login,
  logout,
  getCurrentUser,
  listAdmins,
  updateAdmin,
};

export default authService; 